// #Fase0-B3 — Estatus de plantilla en un solo lugar (contrato C6).
//
//   borrador  → se edita libremente.
//   activa    → se usa para crear evaluaciones; ya no se edita. Para
//               cambiarla se crea una "nueva versión" (borrador hijo).
//   retirada  → la reemplazó una versión nueva: ya no se ofrece para
//               evaluaciones nuevas, pero las existentes siguen con ella.
//   archivada → fuera de uso.
//
// Antes cada pantalla comparaba a mano (y ProjectDetail buscaba 'active',
// que el backend nunca devuelve, así que "Plantillas permitidas" salía
// vacío). Se aceptan los alias en inglés que aún pudieran venir.

const STATUS_ALIASES = {
  draft: 'borrador',
  active: 'activa',
  retired: 'retirada',
  archived: 'archivada',
};

export const TEMPLATE_STATUS = {
  borrador:  { label: 'Borrador',  classes: 'bg-slate-100 text-slate-600 border border-slate-300' },
  activa:    { label: 'Activa',    classes: 'bg-green-100 text-green-800 border border-green-200' },
  retirada:  { label: 'Retirada',  classes: 'bg-amber-50 text-amber-800 border border-amber-200' },
  archivada: { label: 'Archivada', classes: 'bg-slate-200 text-slate-700 border border-slate-400' },
};

export function normalizeTemplateStatus(status) {
  return STATUS_ALIASES[status] || status;
}

export function templateStatusConfig(status) {
  const key = normalizeTemplateStatus(status);
  return TEMPLATE_STATUS[key] || { label: status || '—', classes: 'bg-slate-100 text-slate-600 border border-slate-300' };
}

/** Solo un borrador se edita (igual que _check_editable en la API). */
export function isTemplateEditable(status) {
  return normalizeTemplateStatus(status) === 'borrador';
}

/** "Nueva versión" aplica a plantillas activas o retiradas. */
export function canCreateNewVersion(status) {
  return ['activa', 'retirada'].includes(normalizeTemplateStatus(status));
}

/** Plantillas que se pueden ofrecer para crear evaluaciones nuevas. */
export function isTemplateSelectable(template) {
  return !!template && normalizeTemplateStatus(template.status) === 'activa' && !template.is_archived;
}
